import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Offcanvas from "./Offcanvas";
import { API_BASE_URL } from "../config/config.js";

function Header() {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [menuData, setMenuData] = useState({
    destinations: { title: "Destinations", items: [] },
    themedHolidays: { title: "Themed Holidays", items: [] },
    localPackages: { title: "Local Packages", items: [] },
    safariPackages: {
      title: "Safari Packages",
      items: [
        {
          title: "Maasai Mara",
          value: "maasai-mara",
          image: "./assets/img/header/home-2.jpg",
        },
        {
          title: "Amboseli",
          value: "amboseli",
          image: "./assets/img/header/home-2.jpg",
        },
        {
          title: "Tsavo",
          value: "tsavo",
          image: "./assets/img/header/home-2.jpg",
        },
      ],
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch destinations
        // Check localStorage for cached data
        const cachedData = localStorage.getItem("menuData");
        const cachedTimestamp = localStorage.getItem("menuDataTimestamp");
        const cacheDuration = 3600000; // 1 hour in milliseconds
        const now = Date.now();

        if (
          cachedData &&
          cachedTimestamp &&
          now - cachedTimestamp < cacheDuration
        ) {
          setMenuData(JSON.parse(cachedData));
        } else {
          console.log("Fetching destinations...");
          const destinationsResponse = await fetch(
            `${API_BASE_URL}/api/v1/destinations`
          );
          const destinationsData = await destinationsResponse.json();
          console.log("Raw destinations API response:", destinationsData);

          const groupedDestinations = {
            title: "Destinations",
            items: Object.entries(destinationsData.data).map(
              ([continent, destinations]) => ({
                continent,
                countries: destinations.map((dest) => ({
                  name: dest.name,
                  value: dest.slug,
                })),
              })
            ),
          };
          console.log("Processed destinations:", groupedDestinations);

          // Fetch themed holidays
          console.log("Fetching themed holidays...");
          const themedHolidaysResponse = await fetch(
            `${API_BASE_URL}/api/v1/themed-holidays`
          );
          const themedHolidaysData = await themedHolidaysResponse.json();
          console.log("Raw themed holidays API response:", themedHolidaysData);

          const formattedThemedHolidays = {
            title: "Themed Holidays",
            items: themedHolidaysData.data.map((holiday) => ({
              title: holiday.title,
              value: holiday.value,
              image: holiday.image,
            })),
          };
          console.log("Processed themed holidays:", formattedThemedHolidays);

          // Fetch local packages
          console.log("Fetching local packages...");
          const localPackagesResponse = await fetch(
            `${API_BASE_URL}/api/v1/local-packages`
          );
          const localPackagesData = await localPackagesResponse.json();
          console.log("Raw local packages API response:", localPackagesData);

          const formattedLocalPackages = {
            title: "Local Packages",
            items: localPackagesData.data,
          };
          console.log("Processed local packages:", formattedLocalPackages);

          // Fetch safari packages (assuming tour-packages with category 'Safari')
          // console.log("Fetching safari packages...");
          // const safariPackagesResponse = await fetch(`${API_BASE_URL}/api/v1/tour-packages?category_id=1`); // Adjust category_id for 'Safari'
          // const safariPackagesData = await safariPackagesResponse.json();
          // console.log("Raw safari packages API response:", safariPackagesData);

          // const formattedSafariPackages = {
          //   title: "Safari Packages",
          //   items: safariPackagesData.data.map(pkg => ({
          //     title: pkg.name,
          //     value: pkg.slug,
          //     image: pkg.images?.[0] ? asset('storage/' + pkg.images[0]) : "./assets/img/header/home-2.jpg",
          //   })),
          // };
          // console.log("Processed safari packages:", formattedSafariPackages);

          setMenuData((prevData) => ({
            ...prevData,
            destinations: groupedDestinations,
            themedHolidays: formattedThemedHolidays,
            localPackages: formattedLocalPackages,
            //safariPackages: formattedSafariPackages,
          }));
          console.log("Updated menuData:");
        }
      } catch (error) {
        console.error("Error fetching menu data:", error);
      }
    };

    fetchData();
  }, []);

  const toggleOffcanvas = () => {
    setIsOffcanvasOpen((prev) => !prev);
  };

  return (
    <>
      <header className="header-section-10">
        <div className="header-top-section-new">
          <div className="container-fluid">
            <div className="header-top-wrapper-new">
              <div className="social-icon">
                <span>Follow Us :</span>
                <a href="/contact-us">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="/contact-us">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="/contact-us">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="/contact-us">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
              <ul className="top-right">
                <li>
                  <i className="fa-solid fa-envelope"></i>
                  <a href="mailto:info@fayahtravels.com">
                    info@fayahtravels.com
                  </a>
                </li>
                <li>
                  <i className="fa-solid fa-phone"></i>
                  <a href="tel:+254742940940">+254 742 940 940</a>
                </li>
                <li>
                  <i className="fa-solid fa-location-dot"></i>
                  Lamka Court, Katani Rd, Syokimau
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="header-sticky" className="header-11">
          <div className="container-fluid">
            <div className="mega-menu-wrapper">
              <div className="header-main">
                <div className="logo">
                  <Link to="/" className="header-logo">
                    <img
                      src="./assets/img/logo/fayah-logo.png"
                      alt="logo-img"
                      style={{ height: '60px', objectFit: 'contain' }} // Adjust 60px based on your header height
                    />
                  </Link>
                  <div className="logo-2">
                    <Link to="/">
                      <img
                        src="./assets/img/logo/fayah-logo.png"
                        alt=""
                        style={{ height: '60px', objectFit: 'contain' }} // Match the height of the first logo
                      />
                    </Link>
                  </div>
                </div>
                <div className="header-right d-flex justify-content-end align-items-center">
                  <div className="mean__menu-wrapper">
                    <div className="main-menu">
                      <nav id="mobile-menu">
                        <ul>
                          <li>
                            <Link to="/">Home</Link>
                          </li>
                          {/* Destinations Dropdown */}
                          <li className="has-dropdown active menu-thumb">
                            <Link to="/tour-details?category=destination">
                              {menuData.destinations.title}{" "}
                              <i className="fa-solid fa-chevron-down"></i>
                            </Link>
                            <ul className="submenu">
                              {menuData.destinations.items.map((continent) => (
                                <li
                                  key={continent.continent}
                                  className="has-dropdown"
                                >
                                  <Link to="#">{continent.continent}</Link>
                                  <ul className="submenu">
                                    {continent.countries.map((country) => (
                                      <li key={country.value}>
                                        <Link
                                          to={`/tour-details?category=destination&value=${country.value}`}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <span>Visit {country.name}</span>
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                          <li className="has-dropdown active d-xl-none">
                            <Link
                              to="/tour-details?category=destination"
                              className="border-none"
                            >
                              {menuData.destinations.title}
                            </Link>
                            <ul className="submenu">
                              {menuData.destinations.items.map((continent) => (
                                <React.Fragment key={continent.continent}>
                                  <li>
                                    <Link to="#">{continent.continent}</Link>
                                  </li>
                                  {continent.countries.map((country) => (
                                    <li key={country.value}>
                                      <Link
                                        to={`/tour-details?category=destination&value=${country.value}`}
                                      >
                                        {country.name}
                                      </Link>
                                    </li>
                                  ))}
                                </React.Fragment>
                              ))}
                            </ul>
                          </li>
                          {/* Themed Holidays Dropdown */}
                          <li className="has-dropdown active menu-thumb">
                            <Link to="/tour-details?category=themed-holidays">
                              {menuData.themedHolidays.title}{" "}
                              <i className="fa-solid fa-chevron-down"></i>
                            </Link>
                            <ul className="submenu has-homemenu">
                              <li>
                                <div className="homemenu-items">
                                  {menuData.themedHolidays.items.map((item) => (
                                    <div className="homemenu" key={item.value}>
                                      <div className="homemenu-thumb">
                                        <Link
                                          to={`/tour-details?category=themed-holidays&value=${item.value}`}
                                        >
                                          <img
                                            src={item.image}
                                            alt={item.title}
                                          />
                                        </Link>
                                        <div className="demo-button">
                                          <Link
                                            to={`/tour-details?category=themed-holidays&value=${item.value}`}
                                            className="theme-btn"
                                          >
                                            Visit {item.title}
                                          </Link>
                                        </div>
                                      </div>
                                      <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                          {item.title}
                                        </h4>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li className="has-dropdown active d-xl-none">
                            <Link
                              to="/tour-details?category=themed-holidays"
                              className="border-none"
                            >
                              {menuData.themedHolidays.title}
                            </Link>
                            <ul className="submenu">
                              {menuData.themedHolidays.items.map((item) => (
                                <li key={item.value}>
                                  <Link
                                    to={`/tour-details?category=themed-holidays&value=${item.value}`}
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                          {/* Local Packages Dropdown */}
                          <li className="has-dropdown active menu-thumb">
                            <Link to="/tour-details?category=local-packages">
                              {menuData.localPackages.title}{" "}
                              <i className="fa-solid fa-chevron-down"></i>
                            </Link>
                            <ul className="submenu has-homemenu">
                              <li>
                                <div className="homemenu-items">
                                  {menuData.localPackages.items.map((item) => (
                                    <div className="homemenu" key={item.value}>
                                      <div className="homemenu-thumb">
                                        <Link
                                          to={`/tour-details?category=local-packages&value=${item.value}`}
                                        >
                                          <img
                                            src={item.image}
                                            alt={item.title}
                                          />
                                        </Link>
                                        <div className="demo-button">
                                          <Link
                                            to={`/tour-details?category=local-packages&value=${item.value}`}
                                            className="theme-btn"
                                          >
                                            Visit {item.title}
                                          </Link>
                                        </div>
                                      </div>
                                      <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                          {item.title}
                                        </h4>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </li>
                            </ul>
                          </li>
                          <li className="has-dropdown active d-xl-none">
                            <Link
                              to="/tour-details?category=local-packages"
                              className="border-none"
                            >
                              {menuData.localPackages.title}
                            </Link>
                            <ul className="submenu">
                              {menuData.localPackages.items.map((item) => (
                                <li key={item.value}>
                                  <Link
                                    to={`/tour-details?category=local-packages&value=${item.value}`}
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                          {/* Safari Packages Dropdown */}
                          {/* <li className="has-dropdown active menu-thumb">
                            <Link to="/tour-details?category=safari-packages">
                              {menuData.safariPackages.title}{" "}
                              <i className="fa-solid fa-chevron-down"></i>
                            </Link>
                            <ul className="submenu has-homemenu">
                              <li>
                                <div className="homemenu-items">
                                  {menuData.safariPackages.items.map((item) => (
                                    <div className="homemenu" key={item.value}>
                                      <div className="homemenu-thumb">
                                        <Link
                                          to={`/tour-details?category=safari-packages&value=${item.value}`}
                                        >
                                          <img
                                            src={item.image}
                                            alt={item.title}
                                          />
                                        </Link>
                                        <div className="demo-button">
                                          <Link
                                            to={`/tour-details?category=safari-packages&value=${item.value}`}
                                            className="theme-btn"
                                          >
                                            Visit {item.title}
                                          </Link>
                                        </div>
                                      </div>
                                      <div className="homemenu-content text-center">
                                        <h4 className="homemenu-title">
                                          {item.title}
                                        </h4>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </li>
                            </ul>
                          </li> */}
                          <li className="has-dropdown active d-xl-none">
                            <Link
                              to="/tour-details?category=safari-packages"
                              className="border-none"
                            >
                              {menuData.safariPackages.title}
                            </Link>
                            <ul className="submenu">
                              {menuData.safariPackages.items.map((item) => (
                                <li key={item.value}>
                                  <Link
                                    to={`/tour-details?category=safari-packages&value=${item.value}`}
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                          <li>
                            <Link to="/contact-us">Contact Us</Link>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                  <Link to="#0" className="search-trigger search-icon">
                    <i className="fa-regular fa-magnifying-glass"></i>
                  </Link>
                  <Link to="/contact-us" className="theme-btn style-2">
                    Request A Quote
                    <img src="./assets/img/icon/white-arrow.svg" alt="img" />
                  </Link>
                  <div className="header__hamburger d-xl-none my-auto"></div>
                  <div className="sidebar__toggle">
                    <i className="fas fa-bars"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Offcanvas
        isOffcanvasOpen={isOffcanvasOpen}
        toggleOffcanvas={toggleOffcanvas}
      />
    </>
  );
}

export default Header;
